import { render, staticRenderFns } from "./ReplyComment.vue?vue&type=template&id=cdcf716e&scoped=true&"
import script from "./ReplyComment.vue?vue&type=script&lang=js&"
export * from "./ReplyComment.vue?vue&type=script&lang=js&"
import style0 from "./ReplyComment.vue?vue&type=style&index=0&id=cdcf716e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcf716e",
  null
  
)

component.options.__file = "ReplyComment.vue"
export default component.exports